/* eslint-disable max-len */
/* eslint-disable max-lines */
import { Theme, variantProvider, React, AppImages } from '@/app'
import {
  AppStatusOverlay,
  Page,
  View,
  Text,
  Touchable,
  Image,
  StoreButtons,
} from '@/components'

const featuredInContent = [
  {
    subTitle: 'GLAMOUR UK',
    title: 'Best new dating app: Cherry',
    image: AppImages.GlamourUk,
    url: 'https://www.glamourmagazine.co.uk/gallery/best-dating-sites#:~:text=Best%20new%20dating,pool%E2%80%A6%20for%20now',
    description:
      "Who better to update you on a new route to love than the app's founder? Yep, Cherry is the latest in a long (long) line of dating apps, working to help millennials and Gen Z's-alike to find love — except it's doing it differently.",
  },
  {
    subTitle: 'SKY NEWS',
    title:
      'Phone calls, anti-catfish measures and vegan apps: The frustrated entrepreneurs taking on dating',
    image: AppImages.SkyNews,
    url: 'https://news.sky.com/story/phone-calls-anti-catfish-measures-and-vegan-apps-the-frustrated-entrepreneurs-taking-on-dating-13276624',
    description:
      "People have been coming up with ways to find true love for centuries; from Victorian promenading to tea dancing to lonely hearts columns, we're a species that likes to matchmake. Now, frustrated by traditional dating apps, these entrepreneurs are solving their own problems.",
  },
  {
    subTitle: 'SKY NEWS',
    title: "'It's not you, it's dating': Where is modern love going wrong?",
    image: AppImages.ItsNotYou,
    url: 'https://news.sky.com/story/amp/its-not-you-its-dating-where-is-modern-love-going-wrong-13307076',
    description:
      'Usage of the biggest dating apps is starting to drop, and I want to find out just where we are going wrong with modern dating.',
  },
]

const FeaturedInCard = (props) => {
  return (
    <View css={styles.featuredInCardWrapper}>
      <Touchable
        css={styles.mediaWrapper}
        onPress={() => window.open(props.url, '_blank')}
      >
        <Image
          source={props.image}
          css={styles.contentImage}
          objectFit={'cover'}
        />
      </Touchable>
      <View variants={['column', 'paddingBottom:2']} css={styles.textCardWrapper}>
        <Text
          text={props.subTitle}
          css={styles.subTitleText}
          variants={['extraBold', 'primarySolid300']}
        />
        <Touchable
          css={styles.titleWrapper}
          onPress={() => window.open(props.url, '_blank')}
        >
          <Text
            text={props.title}
            css={[styles.ellipsisTextOggText, styles.ellipsisTextOneLine]}
            variants={['primarySolid600', 'bold', 'oggText']}
          />
        </Touchable>
        <Text
          text={props.description}
          css={[styles.ellipsisTextManrope, styles.ellipsisTextTwoLines]}
          variants={['primarySolid600']}
        />
      </View>
    </View>
  )
}

export const Overlays = () => {
  return (
    <>
      <AppStatusOverlay />
      {/* <DebugModal/> */}
    </>
  )
}

const HomeText = () => (
  <View
    css={styles.descriptionWrapper}
    variants={['column', 'justifyCenter', 'gap:2.5']}
    responsiveVariants={{
      mid: ['alignCenter', 'justifyCenter'],
    }}
  >
    <Text
      css={styles.heroText}
      variants={['oggText']}
    >
      Be the  <br />  real You
    </Text>
    <StoreButtons down={'small'} />
    <Text
      css={styles.subtitleHeroText}
      responsiveVariants={{
        mid: ['textCenter'],
      }}
    >
      Cherry is committed to creating a fun, safe, and honest environment to
      help as many people as possible find the love of their life or a great
      companion. Cherry prioritizes its members and values integrity above all.
    </Text>
    <StoreButtons up={'small'} />
  </View>
)

const IndexPage: React.FC = () => {
  return (
    <Page title='Home' variants={['bare', 'column']} center={true}>
      <View
        css={[
          styles.wrapper,
          styles.innerSpacing,
          {
            backgroundImage: `url(${AppImages.HomeHeroImageDesktop})`,
            [Theme.media.down('mid')]: {
              backgroundImage: `url(${AppImages.HomeHeroImageTablet})`,
            },
            [Theme.media.down('small')]: {
              backgroundImage: `url(${AppImages.HomeHeroImageMobile})`,
            },
          },
        ]}
      >
        <View css={{ maxWidth: 1280 }}>
          <HomeText />
        </View>
      </View>
      <View css={[styles.innerWrapper, styles.featuredInWrapper]}>
        <Text
          text={'Cherry in the media...'}
          css={styles.featuredInTitle}
          variants={['paddingVertical:4', 'oggText']}
        />
        <View css={styles.cardWrapper}>
          {featuredInContent.map((el, index) => (
            <>
              <FeaturedInCard key={el.subTitle} {...el} />
              {index < featuredInContent.length - 1 && (
                <View variants={['verticalSeparator']} css={styles.separatorResponsive} />
              )}
            </>
          ))}
        </View>
      </View>
    </Page>
  )
}

export default IndexPage

const styles = variantProvider.createComponentStyle(
  (theme) => ({
    innerSpacing: {
      [Theme.media.down('xxlarge')]: {
        paddingLeft: Theme.spacing.value(16),
        paddingRight: Theme.spacing.value(16),
      },
      [Theme.media.down('large')]: {
        paddingLeft: Theme.spacing.value(12),
        paddingRight: Theme.spacing.value(12),
      },
      [Theme.media.down('largeish')]: {
        paddingLeft: Theme.spacing.value(8),
        paddingRight: Theme.spacing.value(8),
      },
      [Theme.media.down('mid')]: {
        paddingLeft: Theme.spacing.value(4),
        paddingRight: Theme.spacing.value(4),
      },
      [Theme.media.down('small')]: {
        paddingLeft: Theme.spacing.value(2),
        paddingRight: Theme.spacing.value(2),
      },
    },
    wrapper: {
      minHeight: 821,
      width: '100vw',
      maxWidth: '100%',
      backgroundSize: 'cover',
      backgroundPosition: 'top',
      backgroundRepeat: 'no-repeat',
      justifyContent: 'center',
      paddingTop: theme.spacing.value(20),
      [Theme.media.down('mid')]: {
        backgroundPosition: '100% top',
        minHeight: '160vh',
      },
      [Theme.media.down('small')]: {
        paddingTop: theme.spacing.value(5),
        backgroundPosition: 'center',
        minHeight: '110vh',
      },
    },
    innerWrapper: {
      maxWidth: 1280,
      width: '100%',
      height: '100%',
      ...theme.spacing.paddingTop(4),
      flexDirection: 'column',
    },
    featuredInWrapper: {
      maxWidth: 1280,
      minHeight: 500,

      [Theme.media.down('xxlarge')]: {
        paddingLeft: 0,
        paddingRight: 0,
      },

      [Theme.media.down('xlarge')]: {
        paddingLeft: Theme.spacing.value(12),
        paddingRight: Theme.spacing.value(12),
      },
      [Theme.media.down('largeish')]: {
        paddingLeft: Theme.spacing.value(8),
        paddingRight: Theme.spacing.value(8),
      },
      [Theme.media.down('mid')]: {
        paddingLeft: Theme.spacing.value(4),
        paddingRight: Theme.spacing.value(4),
      },
      [Theme.media.down('small')]: {
        paddingLeft: Theme.spacing.value(2),
        paddingRight: Theme.spacing.value(2),
      },
    },
    cardWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'stretch',
      marginLeft: theme.spacing.value(-2),
      gap: theme.spacing.value(2),

      [Theme.media.down('mid')]: {
        flexDirection: 'column',
        gap: 0,
      },
      [Theme.media.down('small')]: {
        marginLeft: theme.spacing.value(0),
      },
    },
    separatorResponsive: {
      flexShrink: 0,
      alignSelf: 'stretch',
      color: theme.colors.primarySolid300,

      [Theme.media.down('mid')]: {
        width: '100%',
        height: 1,
        marginTop: theme.spacing.value(2),
        marginBottom: theme.spacing.value(2),
      },
    },
    featuredInCardWrapper: {
      flex: 1,
      minWidth: 0,
      flexDirection: 'column-reverse',
      padding: theme.spacing.value(2),

      [Theme.media.down('mid')]: {
        flex: 'none',
        flexDirection: 'row',
        width: '100%',
      },

      [Theme.media.down('small')]: {
        flexDirection: 'column-reverse',
        gap: theme.spacing.value(2),
        padding: theme.spacing.value(0),
      },
    },
    textCardWrapper: {
      flexDirection: 'column',
      width: '100%',
      gap: theme.spacing.value(1),

      [Theme.media.down('mid')]: {
        ...theme.spacing.paddingLeft(3),
        ...theme.spacing.paddingTop(3),
      },

      [Theme.media.down('small')]: {
        ...theme.spacing.paddingLeft(0),
        ...theme.spacing.paddingTop(0),
      },
    },
    storeButtonsWrapper: {
      flexDirection: 'row',
      justifyContent: 'flex-start',
    },
    imagePhone: {
      width: '60%',
      maxHeight: '80vh',
      objectFit: 'contain',
      opacity: 1,
      visibility: 'visible',
      [Theme.media.down('mid')]: {
        width: '100%',
      },
      [Theme.media.down('small')]: {
        opacity: 0,
        visibility: 'hidden',
      },
    },
    descriptionWrapper: {
      zIndex: 9,
      width: '40%',
      [Theme.media.down('mid')]: {
        paddingTop: theme.spacing.value(6),
        justifyContent: 'flex-start',
        alignItems: 'center',
        width: 400,
        maxWidth: '100%',
      },
      [Theme.media.down('small')]: {
        width: '100%',
      },
    },
    loadingWrapper: {
      height: '100vh',
    },
    contentImage: {
      width: '100%',
      height: '100%',
      transition: 'transform 0.3s ease',
      ':hover': {
        transform: 'scale(1.05)',
      },
    },
    mediaWrapper: {
      position: 'relative',
      width: '100%',
      maxHeight: 200,
      aspectRatio: '16/9',
      cursor: 'pointer',
      borderRadius: 16,
      overflow: 'hidden',
      [theme.media.down('mid')]: {
        maxWidth: 280,
        minWidth: 280,
      },
      [theme.media.down('small')]: {
        maxWidth: '100%',
        maxHeight: 200,
      },
    },
    titleWrapper: {
      cursor: 'pointer',
    },
    ellipsisTextOggText: {
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: 24,
      lineHeight: 1.36,
    },
    ellipsisTextManrope: {
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: 18,
      lineHeight: 1.45,
    },
    ellipsisTextOneLine: {
      WebkitLineClamp: 1,
    },
    ellipsisTextTwoLines: {
      WebkitLineClamp: 2,
    },
    heroText: {
      fontSize: 120,
      lineHeight: 1,
      letterSpacing: -0.03,
      color: theme.colors.primarySolid200,
      [Theme.media.down('mid')]: {
        textAlign: 'center',
        fontSize: 104,
      },
      [Theme.media.down('small')]: {
        fontSize: 'clamp(56px, 18vw, 72px)',
      },
    },
    subtitleHeroText: {
      fontWeight: 500,
      fontSize: 20,
      lineHeight: 1.45,
      letterSpacing: -0.02,
      color: theme.colors.primarySolid50,
      [Theme.media.down('small')]: {
        fontSize: 18,
      },
    },
    featuredInTitle: {
      fontSize: 42,
      lineHeight: 1,
      color: theme.colors.primarySolid300,
      [Theme.media.down('small')]: {
        fontSize: 32,
      },
    },
    subTitleText: {
      fontSize: 16,
      lineHeight: 0.72,
      letterSpacing: 0.03,
    },
  }),
  true,
)
